import { DEFAULT_STORE_OBJECT } from '../../../contants/common';
import getTenderListBySearchReq from './requestPayload/GetTenderListBySearch';
import getTenderCopy from './requestPayload/GetTenderCopy';

import ProcurementTenderType from './ProcurementTenderType';

const initialState = {
  tenderList: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
    req: {
      ...getTenderListBySearchReq,
    },
  },
  updateTender: { ...DEFAULT_STORE_OBJECT },

  BidParameterList: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
    req: {
      tenderID: '',
    },
  },

  LaneInformationList: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
  },

  transportProviderList: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
  },

  AddTransportProviderList: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
  },
  addnewbidparameteractions: {
    ...DEFAULT_STORE_OBJECT,
    btnCliked: false,
  },

  historicalBidList: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
  },
  addNewLaneBtnClicked: false,
};

const ProcurementTenderReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ProcurementTenderType.ADD_NEW_LANE_BUTTON: {
      return {
        ...state,
        addNewLaneBtnClicked: payload,
      };
    }
    case ProcurementTenderType.GET_PROCUREMENT_TENDER_LIST: {
      return {
        ...state,
        tenderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.tenderList,
          req: {
            ...state.tenderList.req,
            ...payload,
          },
          progressing: true,
        },
      };
    }
    case ProcurementTenderType.GET_PROCUREMENT_TENDER_LIST_SUCCESS: {
      return {
        ...state,
        tenderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.tenderList,
          success: true,
          data: [...state?.tenderList?.data, ...payload?.data?.tenderViewModel],
          totalModeTest: payload?.data?.totalModeTest,
          totalModeProd: payload?.data?.totalModeProd,
          totalCount: payload?.data?.totalCount,
          progressing: false,
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_TENDER_LIST_FAIL: {
      return {
        ...state,
        tenderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.tenderList,
          error: true,
          data: payload.data,
          progressing: false,
          totalActive: 0,
          totalApproved: 0,
          totalCount: 0,
        },
      };
    }

    case ProcurementTenderType.UPDATE_PROCUREMENT_TENDER_INFO_REQUEST: {
      return {
        ...state,
        req: {
          ...state.getTenderListBySearchReq,
          ...payload,
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_TENDER_LIST_REQUEST_RESET: {
      return {
        ...state,
        tenderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.tenderList,
          req: {
            ...state.tenderList.req,
            ...payload,
          },
          data: [],
        },
      };
    }

    case ProcurementTenderType.CHECK_TENDER_NAME_IS_EXISTS: {
      return {
        ...state,
        checkTenderName: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
        },
      };
    }

    case ProcurementTenderType.CHECK_TENDER_NAME_IS_EXISTS_SUCCESS: {
      return {
        ...state,
        checkTenderName: {
          ...DEFAULT_STORE_OBJECT,
          ...state.checkTenderName,
          success: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case ProcurementTenderType.CHECK_TENDER_NAME_IS_EXISTS_FAIL: {
      return {
        ...state,
        checkTenderName: {
          ...DEFAULT_STORE_OBJECT,
          ...state.checkTenderName,
          error: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    /** Active Tender Item set and reset reducer start */

    case ProcurementTenderType.SET_ACTIVE_TENDER_ITEM: {
      return {
        ...state,
        activeTender: {
          data: payload,
        },
      };
    }

    case ProcurementTenderType.RESET_ACTIVE_TENDER_ITEM: {
      return {
        ...state,
        activeTender: {
          data: {},
        },
      };
    }
    /** Active Tender Item set and reset reducer end */

    case ProcurementTenderType.UPDATE_TENDER_PROGRESS: {
      return {
        ...state,
        updateTender: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
        },
      };
    }

    case ProcurementTenderType.UPDATE_TENDER_SUCCESS: {
      return {
        ...state,
        updateTender: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          ...payload,
        },
      };
    }

    case ProcurementTenderType.UPDATE_TENDER_ERROR: {
      return {
        ...state,
        updateTender: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
        },
      };
    }

    /**Tender Copy reducer start */
    case ProcurementTenderType.CREATE_TENDER_COPY: {
      return {
        ...state,
        tenderCopy: {
          ...DEFAULT_STORE_OBJECT,
          req: {
            ...state.tenderCopy.req,
            ...payload,
          },
          progressing: true,
        },
      };
    }

    case ProcurementTenderType.CREATE_TENDER_COPY_SUCCESS: {
      return {
        ...state,
        tenderCopy: {
          ...DEFAULT_STORE_OBJECT,
          ...state.tenderCopy,
          error: false,
          success: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case ProcurementTenderType.CREATE_TENDER_COPY_FAIL: {
      return {
        ...state,
        tenderCopy: {
          ...DEFAULT_STORE_OBJECT,
          ...state.tenderCopy,
          error: true,
          data: payload,
          success: false,
          progressing: false,
        },
      };
    }

    case ProcurementTenderType.CREATE_TENDER_COPY_RESET: {
      return {
        ...state,
        tenderCopy: {
          ...DEFAULT_STORE_OBJECT,
          ...state.tenderCopy,
          req: {
            ...getTenderCopy,
          },
          success: false,
          error: false,
          data: [],
        },
      };
    }
    /** Tender Copy reducer  end */

    case ProcurementTenderType.GET_DOCUMENTS_PROGRESS: {
      return {
        ...state,
        documentDetails: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
          data: [],
        },
      };
    }

    case ProcurementTenderType.GET_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        documentDetails: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          ...payload,
        },
      };
    }

    case ProcurementTenderType.GET_DOCUMENTS_ERROR: {
      return {
        ...state,
        documentDetails: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
          data: [],
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_BID_PARAMETER: {
      return {
        ...state,
        BidParameterList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.BidParameterList,
          req: {
            ...state.BidParameterList.req,
            ...payload,
          },
          progressing: true,
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_BID_PARAMETER_SUCCESS: {
      return {
        ...state,
        BidParameterList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.BidParameterList,
          success: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_BID_PARAMETER_FAIL: {
      return {
        ...state,
        BidParameterList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.BidParameterList,
          error: true,
          data: payload.data,
          progressing: false,
          totalActive: 0,
          totalApproved: 0,
          totalCount: 0,
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_BID_PARAMETER_REQUEST_RESET: {
      return {
        ...state,
        BidParameterList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.BidParameterList,
          req: {
            ...state.BidParameterList.req,
            payload,
          },
          data: [],
        },
      };
    }

    case ProcurementTenderType.ADD_NEW_BID_PARAMETER_ACTION: {
      return {
        ...state,
        addnewbidparameteractions: {
          ...DEFAULT_STORE_OBJECT,
          btnCliked: payload,
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_LANE_INFORMATION: {
      return {
        ...state,
        LaneInformationList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.LaneInformationList,
          progressing: true,
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_LANE_INFORMATION_SUCCESS: {
      return {
        ...state,
        LaneInformationList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.LaneInformationList,
          success: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_LANE_INFORMATION_FAIL: {
      return {
        ...state,
        LaneInformationList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.LaneInformationList,
          error: true,
          data: payload.data,
          progressing: false,
          totalActive: 0,
          totalApproved: 0,
          totalCount: 0,
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_LANE_INFORMATION_REQUEST_RESET: {
      return {
        ...state,
        LaneInformationList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.LaneInformationList,
          req: {
            ...state.LaneInformationList.req,
            payload,
          },
          data: [],
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_ADD_LANE_INFORMATION: {
      return {
        ...state,
        AddLaneInformationList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.AddLaneInformationList,
          progressing: true,
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_ADD_LANE_INFORMATION_SUCCESS: {
      return {
        ...state,
        AddLaneInformationList: {
          ...state.AddLaneInformationList,
          success: true,
          data: payload.data.data,
          progressing: false,
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_ADD_LANE_INFORMATION_FAIL: {
      return {
        ...state,
        AddLaneInformationList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.AddLaneInformationList,
          error: true,
          data: payload?.data,
          progressing: false,
          totalActive: 0,
          totalApproved: 0,
          totalCount: 0,
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_ADD_LANE_INFORMATION_REQUEST_RESET: {
      return {
        ...state,
        AddLaneInformationList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.AddLaneInformationList,
          req: {
            ...state.AddLaneInformationList.req,
            payload,
          },
          data: [],
        },
      };
    }

    case ProcurementTenderType.GET_TENDER_CARRIER_LIST: {
      return {
        ...state,
        transportProviderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.transportProviderList,

          progressing: true,
        },
      };
    }

    case ProcurementTenderType.GET_TENDER_CARRIER_LIST_SUCCESS: {
      return {
        ...state,
        transportProviderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.transportProviderList,
          success: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case ProcurementTenderType.GET_TENDER_CARRIER_LIST_FAIL: {
      return {
        ...state,
        transportProviderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.transportProviderList,
          error: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case ProcurementTenderType.GET_TENDER_CARRIER_LIST_REQUEST_RESET: {
      return {
        ...state,
        transportProviderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.transportProviderList,
          req: {
            ...state.transportProviderList.req,
            payload,
          },
          data: [],
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_ADD_TRANSPORT_PROVIDER_LIST: {
      return {
        ...state,
        AddTransportProviderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.AddTransportProviderList,

          progressing: true,
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_ADD_TRANSPORT_PROVIDER_SUCCESS: {
      return {
        ...state,
        AddTransportProviderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.AddTransportProviderList,
          success: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_ADD_TRANSPORT_PROVIDER_FAIL: {
      return {
        ...state,
        AddTransportProviderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.AddTransportProviderList,
          error: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_ADD_TRANSPORT_PROVIDER_REQUEST_RESET: {
      return {
        ...state,
        AddTransportProviderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.AddTransportProviderList,
          req: {
            ...state.AddTransportProviderList.req,
            payload,
          },
          data: [],
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_HISTORICAL_BID_LIST: {
      return {
        ...state,
        historicalBidList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.historicalBidList,
          req: {
            ...state.historicalBidList.req,
            ...payload,
          },
          progressing: true,
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_HISTORICAL_BID_LIST_SUCCESS: {
      return {
        ...state,
        historicalBidList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.historicalBidList,
          success: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_HISTORICAL_BID_LIST_FAIL: {
      return {
        ...state,
        historicalBidList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.historicalBidList,
          error: true,
          data: payload.data,
          progressing: false,
          totalActive: 0,
          totalApproved: 0,
          totalCount: 0,
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_HISTORICAL_BID_LIST_REQUEST_RESET: {
      return {
        ...state,
        historicalBidList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.historicalBidList,
          req: {
            ...state?.historicalBidList?.Req,
            ...payload,
          },
          data: [],
          totalActive: 0,
          totalApproved: 0,
          totalCount: 0,
        },
      };
    }

    default:
      return state;
  }
};

export default ProcurementTenderReducer;
